module.exports = __webpack_public_path__ + "static/media/21_Are you still here.77224aaf.jpg";